import React from "react";
import { whyNcetData } from "../../data/home";
import highlight from "./highlight";
import "./homeRedesign.css";

const WhyNcet = () => {
  const { eyebrow, heading, subtitle, items, highlight: hl } = whyNcetData;

  return (
    <section className="why-ed" aria-labelledby="why-ed-title">
      <div className="container">
        <div className="section-head-ed">
          <span className="eyebrow-ed">{eyebrow}</span>
          <h2 id="why-ed-title" className="heading-ed">{highlight(heading, hl)}</h2>
          <p className="section-sub-ed">{subtitle}</p>
        </div>

        <div className="why-ed__grid">
          {items.map((item, i) => (
            <article className="why-ed__card" key={i}>
              <span className="why-ed__no">{item.no}</span>
              <h3 className="why-ed__title">{item.title}</h3>
              <p className="why-ed__desc">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNcet;
